import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Home from './pages/Home';
import ContactDetails from './pages/ContactDetails';  
import ProtectedRoute from './pages/ProtectedRoute';
import Logout from './pages/Logout';
import Navbar from './pages/Navbar';  
import Footer from './pages/Footer';  
import About from './pages/About';    
import Services from './pages/Services';  
import Contact from './pages/Contact';    
import TOS from './pages/TOS';  // Terms of Service page
import PrivacyPolicy from './pages/PrivacyPolicy';  // Privacy Policy page
import './index.css';  // Tailwind CSS

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col justify-between">
        <Navbar />  {/* Navbar will be visible on all pages */}
        <div className="flex-grow">
          <Routes>
            {/* Home Route */}
            <Route path="/" element={<Home />} />

            {/* Admin Login Route */}
            <Route path="/login" element={<AdminLogin />} />

            {/* Logout Route */}
            <Route path="/logout" element={<Logout />} />

            {/* About Us Route */}
            <Route path="/about" element={<About />} />

            {/* Services Route */}
            <Route path="/services" element={<Services />} />

            {/* Contact Us Route */}
            <Route path="/contact" element={<Contact />} />

            {/* Terms of Service Route */}
            <Route path="/tos" element={<TOS />} />

            {/* Privacy Policy Route */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* Protected Dashboard Route */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            {/* Contact Details Route */}
            <Route
              path="/contacts/:contactId"
              element={
                <ProtectedRoute>
                  <ContactDetails />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
        <Footer />  {/* Footer added here to appear on all pages */}
      </div>
    </Router>
  );
}

export default App;

